import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "app/shared/services/api.service";
import swal from "sweetalert2";
import { User } from "app/shared/models/user.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
// cdkDrag
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";

interface Section {
  id: string;
  name: string;
  course: string;
  isEditing: boolean;
}
interface Chapter {
  id: string;
  name: string;
  section: string;
  isEditing: boolean;
}
interface Topic {
  id: string;
  name: string;
  chapter: string;
  isEditing: boolean;
}

@Component({
  selector: "app-lms-layout",
  templateUrl: "./lms-layout.component.html",
  styleUrls: ["./lms-layout.component.scss"],
})
export class LmsLayoutComponent implements OnInit {
  section: any;
  chapter: any;
  topic: any;
  courseId: string;
  studentId: string;
  sections: any = [];
  options: Array<{ title: string, items: any[] }> = [];
  selectedTopics: any = [];
  appsByTopic: any[] = [];
  topicId: any;
  courseData: any;
  activeSectionName: string = "";
  activeChapterName: string = "";
  activeTopicName: string = "";
  activeSectionId: string = "";
  activeChapterId: string = "";
  activeTopicId: string = "";
  isReadMode: boolean = false;
  isSideBarHidden: boolean;
  user: User;
  teaching_time = new Date();

  // cdkDrag
  grandfathers: any[] = [
    {
      name: "Grandfather 1",
      children: [
        {
          name: "Father 1",
          children: [{ name: "Child 1" }, { name: "Child 2" }],
        },
        {
          name: "Father 2",
          children: [{ name: "Child 3" }, { name: "Child 4" }],
        },
      ],
    },
    {
      name: "Grandfather 2",
      children: [
        {
          name: "Father 4",
          children: [{ name: "Child 5" }, { name: "Child 6" }],
        },
        {
          name: "Father 5",
          children: [{ name: "Child 7" }, { name: "Child 8" }],
        },
      ],
    },
  ];
  empType:any=[]
  searchText$: Subject<string> = new Subject<string>();
  searchTerm: string = '';
  flattenedItems: any[] = [];
  expandAll: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {
    this.route.queryParams.subscribe((params) => {
      this.courseId = params["id"];
      this.studentId = params["stud"];
      this.getCourseById();
      this.getSectionsByCourse(this.courseId, this.studentId);
    });
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.roles !== "admin") {
      this.empType = JSON.parse(localStorage.getItem("empType"));
      this.empType = this.empType.map(item =>item.displayname)
    }
    
  }
  ngOnInit(): void {
    this.searchText$.pipe(
      debounceTime(300), // Adjust debounce time as needed
      distinctUntilChanged(), // Only emit when the current value is different than the last
      switchMap(text => {
        this.searchTerm = text;    // Update the search term
        return this.api.search_sections_chapters_topics(this.courseId, text); // Return the API call observable
      })).subscribe((res:any) => {
      const { data } = res;
      this.options = [
        { title: 'Section', items: data?.sections || [] },
        { title: 'Chapter', items: data?.chapters || [] },
        { title: 'Topic', items: data?.topics || [] },
      ];
      this.flattenItems();
      this.cdr.detectChanges();
    });
  }
  onSearch(text: string) {
    if (!text) {
      this.flattenItems();
      return;
    }
    this.searchText$.next(text);
  }
  flattenItems(): void {
    this.flattenedItems = this.options.flatMap(option => 
      option.items.map(item => ({ ...item, category: option.title }))
    );
  }
  getAppsByTopic(id, topics?) {
    let pageSize = 25;
    let pageNo = 1;
    this.topicId = id;
    this.selectedTopics = topics;
    this.api.getAppsByTopic(id, pageSize, pageNo).subscribe((res: any) => {
      if (res.isSuccess) {
        this.appsByTopic = res.data.map((item) => item.app);
        if (this.isReadMode) this.isSideBarHidden = !this.isSideBarHidden;
      }
    });
  }
  activeBreadcrumb(
    sectionName?,
    sectionId?,
    chapterName?,
    chapterId?,
    topicName?,
    topicId?
  ) {
    (this.activeSectionName = sectionName),
      (this.activeChapterName = chapterName),
      (this.activeTopicName = topicName);
    (this.activeSectionId = sectionId),
      (this.activeChapterId = chapterId),
      (this.activeTopicId = topicId);
  }
  selectItemfromSearchList(item) {
    switch (item.category) {
      case "Section":
        const selectedSection = this.sections.find(section => section._id === item._id);
        if (selectedSection) {
          this.activeBreadcrumb(selectedSection.name, selectedSection._id);
    
          // Check if there are chapters, and auto-activate the first chapter if no active chapter
          if (selectedSection.chapters && selectedSection.chapters.length > 0) {
            selectedSection.collapsed = true;
            selectedSection.chapters[0].collapsed = true;
            const firstChapter = selectedSection.chapters[0];
            this.activeBreadcrumb(
              selectedSection.name,
              selectedSection._id,
              firstChapter.name,
              firstChapter._id
            );
  
            // Check if there are topics and auto-activate the first topic if no active topic
            if (firstChapter.topics && firstChapter.topics.length > 0) {
              const firstTopic = firstChapter.topics[0];
              this.activeBreadcrumb(
                selectedSection.name,
                selectedSection._id,
                firstChapter.name,
                firstChapter._id,
                firstTopic.name,
                firstTopic._id
              );
              this.getAppsByTopic(firstTopic._id, firstChapter.topics);
            }
          }
        }
        break;
  
        case "Chapter":
          this.sections.forEach((section, sectionIndex) => {
            // Iterate through each chapter to find the matching one and capture the chapter index
            section.chapters.forEach((chapter, chapterIndex) => {
              if (chapter._id === item._id) {
                this.sections[sectionIndex].collapsed = true;  // Expand the section
                this.activeBreadcrumb(section.name, section._id, chapter.name, chapter._id);
        
                // Auto-activate the first topic of the chapter if no active topic
                if (chapter.topics && chapter.topics.length > 0) {
                  this.sections[sectionIndex].chapters[chapterIndex].collapsed = true;  // Expand the chapter
                  const firstTopic = chapter.topics[0];
                  this.activeBreadcrumb(
                    section.name,
                    section._id,
                    chapter.name,
                    chapter._id,
                    firstTopic.name,
                    firstTopic._id
                  );
                  this.getAppsByTopic(firstTopic._id, chapter.topics);
                }
              }
            });
          });
          break;
        
      case "Topic":
        this.sections.forEach((section,sectionIndex) => {
          section.chapters.forEach((chapter,chapterIndex) => {
            const selectedTopic = chapter.topics.find(topic => topic._id === item._id);
            if (selectedTopic) {
              this.sections[sectionIndex].collapsed = true;
              this.sections[sectionIndex].chapters[chapterIndex].collapsed = true;
              this.activeBreadcrumb(
                section.name,
                section._id,
                chapter.name,
                chapter._id,
                selectedTopic.name,
                selectedTopic._id
              );
              this.getAppsByTopic(selectedTopic._id, chapter.topics);
            }
          });
        });
        break;
  
      default:
        // No category matched
        break;
    }
  }

  searchAndGetAppsInACourse() {
    if (this.searchTerm) { // Only proceed if text is provided
      this.api.searchAndGetAppsInACourse(this.courseId, this.searchTerm).subscribe((res: any) => {
        if (res.isSuccess) {
          this.appsByTopic = res.data.map((item) => item.app);
        }
      });
    }
  }
  getSectionsByCourse(id, studentId?) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.api.getSectionsByCourse(id, studentId).subscribe((res: any) => {
      if (res.isSuccess) {
        this.spinner.hide();
        this.sections = res?.data?.sections;
        this.sections[0].collapsed = true;
        this.sections[0].chapters[0].collapsed = true;
        let topic_id = this.sections[0].chapters[0].topics[0]._id;
        let topics = this.sections[0].chapters[0].topics;

        this.getAppsByTopic(topic_id, topics);

        this.activeSectionName = this.sections[0].name;
        this.activeSectionId = this.sections[0]._id;
        this.activeChapterName = this.sections[0].chapters[0].name;
        this.activeChapterId = this.sections[0].chapters[0]._id;
        this.activeTopicName = this.sections[0].chapters[0].topics[0].name;
        this.activeTopicId = this.sections[0].chapters[0].topics[0]._id;
        this.activeBreadcrumb(
          this.activeSectionName,
          this.activeSectionId,
          this.activeChapterName,
          this.activeChapterId,
          this.activeTopicName,
          this.activeTopicId
        );
      }
    });
  }

  addItem(dataType, event, typeId, sectionIndex?, chapterIndex?) {
    event.stopPropagation();
    if (dataType == "section") {
      this.section = {
        name: "section",
        course: typeId,
      };
      // this.section.isEditing = true;
      this.api.addSection(this.section).subscribe((res: any) => {
        if (res.isSuccess) this.sections.push(res.data);
        this.toastr.success('new section added!')
        // this.getSectionsByCourse(this.courseId)
      });
    } else if (dataType == "chapter") {
      // this.section.isEditing = true;
      this.chapter = {
        name: "chapter",
        section: typeId,
      };
      this.api.addChapter(this.chapter).subscribe((res: any) => {
        //  let index= this.sections.findIndex((item)=>item._id==typeId)
        if (res.isSuccess) this.sections[sectionIndex].chapters.push(res.data);
        this.toastr.success('new chapter added!')
        // this.getSectionsByCourse(this.courseId)
      });
    } else {
      // this.items.push(this.section)
      this.topic = {
        name: "topic",
        chapter: typeId,
      };
      this.api.addTopic(this.topic).subscribe((res: any) => {
        if (res.isSuccess)
          this.toastr.success('new topic added!')
          this.sections[sectionIndex].chapters[chapterIndex].topics.push(
            res.data
          );
        // this.getSectionsByCourse(this.courseId)
      });
    }
  }

  editItem(event, dataType, sectionIndx?, chapterIndx?, TopicIndx?) {
    event.stopPropagation();
    if (dataType == "section") {
      this.sections[sectionIndx].isEditing = false;
      this.api
        .updateSection(this.sections[sectionIndx])
        .subscribe((res: any) => {
          // this.getSectionsByCourse(this.courseId)
        });
    } else if (dataType == "chapter") {
      this.sections[sectionIndx].chapters[chapterIndx].isEditing = false;
      this.api
        .updateChapter(this.sections[sectionIndx].chapters[chapterIndx])
        .subscribe((res: any) => {
          // this.getSectionsByCourse(this.courseId)
        });
    } else {
      this.sections[sectionIndx].chapters[chapterIndx].topics[
        TopicIndx
      ].isEditing = false;
      this.api
        .updateTopic(
          this.sections[sectionIndx].chapters[chapterIndx].topics[TopicIndx]
        )
        .subscribe((res: any) => {
          // this.getSectionsByCourse(this.courseId)
        });
    }
    // }
  }

  deleteItem(event, dataType, id, sectionIndx?, chapterIndx?, topicIndx?) {
    event.stopPropagation();
    if (dataType == "section") {
      this.api.deleteSection(id).subscribe((res: any) => {
        if (res.statusCode === 200) {
          swal.fire({
            icon: "success",
            title: "Deleted!",
            text: `${res.message}`,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.sections.splice(sectionIndx, 1);
          this.getCourseById();
        } else {
          swal.fire({
            title: "Error",
            text: `${res.error}`,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    } else if (dataType == "chapter") {
      this.api.deleteChapter(id).subscribe((res: any) => {
        if (res.statusCode === 200) {
          swal.fire({
            icon: "success",
            title: "Deleted!",
            text: `${res.message}`,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.sections[sectionIndx].chapters.splice(chapterIndx, 1);
          this.getCourseById();
        } else {
          swal.fire({
            title: "Error",
            text: `${res.error}`,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    } else {
      this.api.deleteTopic(id).subscribe((res: any) => {
        if (res.statusCode === 200) {
          swal.fire({
            icon: "success",
            title: "Deleted!",
            text: `${res.message}`,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.sections[sectionIndx].chapters[chapterIndx].topics.splice(
            topicIndx,
            1
          );
          this.getCourseById();
        } else {
          swal.fire({
            title: "Error",
            text: `${res.error}`,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    }
  }
  getCourseById() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.api.getCourseById(this.courseId).subscribe((res: any) => {
      this.spinner.hide();
      this.courseData = res.data[0];
    });
  }
  confirmDelete(event, dataType, id, sectionIndx?, chapterIndx?, TopicIndx?) {
    event.stopPropagation();
    swal
      .fire({
        title: "Are you sure?",
        text: "You won't be able to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2F8BE6",
        cancelButtonColor: "#F55252",
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      })
      .then((result) => {
        if (result.value) {
          this.deleteItem(
            event,
            dataType,
            id,
            sectionIndx,
            chapterIndx,
            TopicIndx
          );
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  openModal_forSection(content, sectionId, teachData, sectionIndex, event) {
    let body = {
      courseId: this.courseId,
      sectionId: sectionId,
      chapterId: "",
      topicId: "",
      teaching_time: "",
      teach: teachData,
    };
    const modalRef = this.modalService.open(content);

    modalRef.result.then(
      (result) => {},
      (reason) => {
        if (reason) {
          body.teaching_time = reason;
          this.api.readLmsTopic(this.studentId, body).subscribe((res: any) => {
            if (res.statusCode === 200) {
              if (teachData == "section") {
                this.toggleSectionClicked(sectionIndex, event);
              }
            } else {
              this.toastr.error(res.error);
            }
          });
        }
      }
    );
  }
  openModal_forChapter(
    content,
    sectionId,
    chapterId,
    teachData,
    sectionIndex,
    chapterIndex,
    event
  ) {
    let body = {
      courseId: this.courseId,
      sectionId: sectionId,
      chapterId: chapterId,
      topicId: "",
      teaching_time: "",
      teach: teachData,
    };
    const modalRef = this.modalService.open(content);

    modalRef.result.then(
      (result) => {},
      (reason) => {
        if (reason) {
          body.teaching_time = reason;
          this.api.readLmsTopic(this.studentId, body).subscribe((res: any) => {
            if (res.statusCode === 200) {
              if (teachData == "chapter") {
                this.toggleChapterClicked(sectionIndex, chapterIndex, event);
              }
            } else {
              this.toastr.error(res.error);
            }
          });
        }
      }
    );
  }

  openModal_forTopic(
    content,
    sectionId: number,
    chapterId: number,
    topicId: number,
    teach_data,
    sectionIndex: number,
    chapterIndex: number,
    topicIndex: number,
    event
  ) {
    let body = {
      courseId: this.courseId,
      sectionId: sectionId,
      chapterId: chapterId,
      topicId: topicId,
      teaching_time: "",
      teach: teach_data,
    };
    const modalRef = this.modalService.open(content);

    modalRef.result.then(
      (result) => {},
      (reason) => {
        if (reason) {
          body.teaching_time = reason;
          this.api.readLmsTopic(this.studentId, body).subscribe((res: any) => {
            if (res.statusCode === 200) {
              if (teach_data == "topic") {
                this.toggleTopicClicked(
                  sectionIndex,
                  chapterIndex,
                  topicIndex,
                  event
                );
              }
            } else {
              this.toastr.error(res.error);
            }
          });
        }
      }
    );
  }

  toggleTopicClicked(
    sectionIndex: number,
    chapterIndex: number,
    topicIndex: number,
    event
  ) {
    event.stopPropagation();
    this.sections[sectionIndex].chapters[chapterIndex].topics[
      topicIndex
    ].clicked =
      !this.sections[sectionIndex].chapters[chapterIndex].topics[topicIndex]
        .clicked;
    const allClicked = this.sections[sectionIndex].chapters[
      chapterIndex
    ].topics.every((topic) => topic.clicked);
    this.sections[sectionIndex].chapters[chapterIndex].clicked = allClicked;
    const allClickedInAllChapters = this.sections.every((section) =>
      section.chapters.every((chapter) =>
        chapter.topics.every((topic) => topic.clicked)
      )
    );
    this.sections[sectionIndex].clicked = allClickedInAllChapters;
  }

  toggleChapterClicked(sectionIndex: number, chapterIndex: number, event) {
    event.stopPropagation();
    this.sections[sectionIndex].chapters[chapterIndex].clicked =
      !this.sections[sectionIndex].chapters[chapterIndex].clicked;
    const allClicked = this.sections.every((section) =>
      section.chapters.every((chapter) =>
        chapter.topics.every((topic) => topic.clicked)
      )
    );
    this.sections[sectionIndex].clicked = allClicked;
  }

  toggleSectionClicked(sectionIndex: number, event) {
    this.sections[sectionIndex].clicked = !this.sections[sectionIndex].clicked;
  }
  submit() {
    this.modalService.dismissAll(this.teaching_time);
  }
  onDrop(event: CdkDragDrop<any>, type: string) {
    
    if (this.user?.roles !== "admin" && !this.empType.includes('Teacher')) return;
    swal
      .fire({
        title: `Do you want to change?`,
        // html: 'You can use <b>bold text</b>, ' +
        //   '<a href="https://pixinvent.com/" target="_blank">links</a> ' +
        //   'and other HTML tags',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger ml-1",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          if (event.previousContainer === event.container) {
            // Reorder items within the same list
            if (event.container.id === "items") {
              let section = {
                indexFrom: event.previousIndex,
                indexTo: event.currentIndex,
                courseId: this.courseId,
              };
              // Reorder sections
              moveItemInArray(
                this.sections,
                event.previousIndex,
                event.currentIndex
              );
              this.api
                .changeOrder(type, section)
                .subscribe((res: any) => this.toastr.success('Order updated successfully!'));
            } else {
              if (type == "chapters") {
                let chapter = {
                  moveFrom: event.previousIndex,
                  moveTo: event.currentIndex,
                  sectionFrom: event.item.data.section,
                  sectionTo: event.item.data.section,
                };
                this.api
                  .changeOrder(type, chapter)
                  .subscribe((res: any) => this.toastr.success('Order updated successfully!'));
              } else {
                let topic = {
                  moveFrom: event.previousIndex,
                  moveTo: event.currentIndex,
                  chapterTo: event.item.data.chapter,
                  chapterFrom: event.item.data.chapter,
                };
                this.api
                  .changeOrder(type, topic)
                  .subscribe((res: any) => this.toastr.success('Order updated successfully!'));
              }
              // Reorder chapters or topics
              moveItemInArray(
                event.container.data,
                event.previousIndex,
                event.currentIndex
              );
            }
          } else {
            // Move item to a different list
            if (event.previousContainer.id === "items") {
              // Move section to chapter list
              transferArrayItem(
                this.sections,
                event.container.data,
                event.previousIndex,
                event.currentIndex
              );
            } else {
              // Move chapter to topic list or vice versa
              transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
              );
            }
          }
        }
      });
  }
  openNewTab(slug) {
    window.open(`/course/${slug}`, "_blank");
  }
  gotoMeanderLink(slug) {
    window.open(`https://meander.training/course-details/${slug}`, "_blank");
  }
  gotoSession(id) {
    window.open(`/classes/sessions?id=${id}`, "_blank");
  }
  // Assuming `sections` is your array containing sections and each section has a `collapsed` property
  toggleExpandAll(expand: boolean) {
    this.expandAll = expand;
    this.sections.forEach(section => {
      section.collapsed = !expand;
      section.chapters.forEach(chapter => {
        chapter.collapsed = !expand;
      });
    });
  }

  
}
